import { z } from 'zod';

const envSchema = z.object({
  VITE_API_ORIGIN: z.union([z.literal(''), z.url({ protocol: /^https?$/ })]).default(''),
  MODE: z.string(),
});

/** Validated once at startup; a misconfigured build fails loudly instead of misbehaving. */
export const env = envSchema.parse(import.meta.env);
